var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarYellow = function SvgStarYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star-yellow_svg__a)",
    d: "M38.992 16.734a1.143 1.143 0 0 0-.651-1.918l-11.009-1.712a1.14 1.14 0 0 1-.852-.63L21.47 2.146c-.419-.864-1.65-.858-2.061.01l-4.914 10.38c-.16.338-.477.577-.846.638L2.655 15a1.143 1.143 0 0 0-.633 1.924l8.016 8.249c.25.256.364.614.31.967L8.6 37.717a1.143 1.143 0 0 0 1.68 1.173l9.762-5.352a1.14 1.14 0 0 1 1.088-.005l9.813 5.252a1.143 1.143 0 0 0 1.667-1.189l-1.857-11.562a1.14 1.14 0 0 1 .301-.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star-yellow_svg__b)",
    d: "M19.41 2.155c.41-.866 1.64-.872 2.06-.01l2.709 5.585C18.865 12.315 15.5 19.098 15.5 26.667c0 2.999.529 5.875 1.497 8.54l-6.719 3.684A1.143 1.143 0 0 1 8.6 37.718l1.749-11.58c.053-.352-.061-.71-.31-.966l-8.017-8.25A1.143 1.143 0 0 1 2.655 15l10.994-1.824c.37-.062.686-.3.846-.639z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "star-yellow_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.52487 29.2394 -57.0059 8.08824 35.045 13.636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FFC962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#ED582A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-yellow_svg__b",
    x1: 8.178,
    x2: 21.402,
    y1: 30.229,
    y2: 7.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF71",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.83
  })))));
};
export default SvgStarYellow;